import React, { FC, useRef } from 'react';
import styled, { FlattenInterpolation, ThemeProps, DefaultTheme, css } from 'styled-components';
import { up } from 'styled-breakpoints';
import { Focus } from '@fenderdigital/ui/utils/css';

interface CategoryButtonprops {
  buttonClick: () => void;
  category: any;
  instrument: string;
}

const buttonActive = css`
  background-color: ${({ theme }): string => theme.colors.black};
  color: ${({ theme }): string => theme.colors.white};
`;

const Button = styled.button<{ isActive: boolean }>`
  display: flex;
  align-items: center;
  width: fit-content;
  height: 2rem;
  padding: 0.375rem 0.5rem;
  border-radius: 2.375rem;
  border: 1px solid ${({ theme }): string => theme.colors.black};
  font-size: ${({ theme }): string => theme.fontSizes.f2};
  text-transform: capitalize;

  ${up('phone')} {
    padding: 0.375rem 1rem;
  }

  ${({ isActive }): FlattenInterpolation<ThemeProps<DefaultTheme>> =>
    isActive
      ? buttonActive
      : css`
          background-color: ${({ theme }): string => theme.colors.white};
          color: ${({ theme }): string => theme.colors.black};
        `}

  &:hover,
  :active {
    ${buttonActive}
  }

  ${Focus}
`;

const CategoryButton: FC<CategoryButtonprops> = ({ buttonClick, category, instrument }) => {
  const buttonRef = useRef<HTMLButtonElement>(null);

  const buttonFocus = (): void => buttonRef?.current?.focus();

  const handleButtonClick = (): void => {
    buttonClick();
    buttonFocus();
  };

  return (
    <Button
      onClick={handleButtonClick}
      isActive={category.id === instrument}
      key={category.id}
      ref={buttonRef}
    >
      {`${category.id} (${category.subTitle})`}
    </Button>
  );
};

export default CategoryButton;